import request from '@/plugins/request';
let Api = {};
const sys = '/user/'
const pre = 'role_info';
// 列表
Api.tableList = function (data) {
    return request({
        url: `${sys}${pre}_page`,
        method: 'get',
        params: data
    });
}
// 查看
Api.getTableById = function (id) {
    return request({
        url: `${sys}${pre}_id/${id}`,
        method: 'get'
    });
}
// 新增
Api.addTable = function (data) {
    return request({
        url: `${sys}${pre}`,
        method: 'post',
        data
    });
}
// 编辑
Api.editTable = function (data) {
    return request({
        url: `${sys}${pre}`,
        method: 'patch',
        data
    });
}
// 删除
Api.deleteTable = function (id) {
    return request({
        url: `${sys}${pre}/${id}`,
        method: 'delete'
    });
}
// 批量删除
Api.deleteTableAll = function (ids) {
    return request({
        url: `${sys}${pre}_ids/${ids}`,
        method: 'delete'
    });
}
// 用户查角色
Api.getRolesByUser = function (data) {
    return request({
        url: `${sys}${pre}/user_roles`,
        method: 'post',
        data
    });
}
// 群组查角色
Api.getRolesByGroup = function (data) {
    return request({
        url: `${sys}${pre}/group_roles`,
        method: 'post',
        data
    });
}
// 菜单查角色
Api.getRolesByMenu = function (data) {
    return request({
        url: `${sys}${pre}/menu`,
        method: 'post',
        data
    });
}
// 表格查角色
Api.getRolesByTable = function (data) {
    return request({
        url: `${sys}${pre}/table_roles`,
        method: 'post',
        data
    });
}
// 按钮查角色
Api.getRolesByButton = function (data) {
    return request({
        url: `${sys}${pre}/button_roles`,
        method: 'post',
        data
    });
}
export default Api



// WEBPACK FOOTER //
// ./src/api/system/role.js